const { getVariableForEdge, getScale, getDistributionForVariable, getListOfVariablesFromTerminalNodeToRoot, getListOfDistributions } = require("./showChart");
const { convolute, mixture, convoluteMultipleDistributions } = require("./convolution");

document.addEventListener("SilverDecisionsRecomputedEvent", function(e){
    
    const treeExists =  e.detail.dataModel.nodes.length > 1

    if (treeExists){
        var nodesWithErrors = getNodeIdsWithErrors(e.detail.treeDesigner.data.validationResults)

        var variables = e.detail.definitionsDialog.valueList
        var nodes = e.detail.dataModel.nodes
        var nodesToUpdate = []
        var SCALE = 1
        for (var i = 0; i < nodes.length; i++) {
            let node = nodes[i]
            if (node.charts && node.charts.length > 0 && node.charts.some(c => c.active)) {
                nodesToUpdate.push(node)
            }
            if (!node.$parent) {
                SCALE = Math.max(SCALE, getScale(Math.max(...getExpectedEdgeAbsoluteValues(node, variables))))
            }
        }
        for (let i = 0; i < nodes.length; i++) {
            if (!nodes[i].$parent) {
                evaluateTree(nodes[i],0)
            }
            if (nodes[i].type == 'terminal') {
                calculateTerminalNode(nodes[i])
            }
        }
 
        for (let i = 0; i < nodes.length; i++) {
                if (!nodes[i].$parent) {
                    printOptimalPath(nodes[i])
                }      
        }
        if (nodesToUpdate.length > 0) {
            document.dispatchEvent(new CustomEvent('DrawChartsOnCanvases',
            {detail: {nodes: nodesToUpdate, variables: variables, formatter: e.detail.payoffNumberFormat}}
            ))
        }
    }

    let decisionNodes = Array.from(document.getElementsByClassName('decision-node'));
    decisionNodes.forEach(node => {
        let nodeWithoutChart = node.querySelector('path');
        nodeWithoutChart.setAttribute('data-toggle', 'tooltip');
        nodeWithoutChart.setAttribute('data-placement', 'bottom');
        nodeWithoutChart.setAttribute('data-delay', JSON.stringify({"show":"500"}));
        nodeWithoutChart.setAttribute('title', 'Decision node');
    });

    let chanceNodes = Array.from(document.getElementsByClassName('chance-node'));
    chanceNodes.forEach(node => {
        let nodeWithoutChart = node.querySelector('path');
        nodeWithoutChart.setAttribute('data-toggle', 'tooltip');
        nodeWithoutChart.setAttribute('data-placement', 'bottom');
        nodeWithoutChart.setAttribute('data-delay', JSON.stringify({"show":"500"}));
        nodeWithoutChart.setAttribute('title', 'Chance node');
    });

    let terminalNodes = Array.from(document.getElementsByClassName('terminal-node'));
    terminalNodes.forEach(node => {
        let nodeWithoutChart = node.querySelector('path');
        nodeWithoutChart.setAttribute('data-toggle', 'tooltip');
        nodeWithoutChart.setAttribute('data-placement', 'bottom');
        nodeWithoutChart.setAttribute('data-delay', JSON.stringify({"show":"500"}));
        nodeWithoutChart.setAttribute('title', 'Terminal node');
    });

    $(document).ready(function(){
        let tooltip = $('[data-toggle="tooltip"]')
        
        tooltip.tooltip({
            trigger : 'hover',
            'delay': { "show": 500 },
        })
        
        tooltip.on('click', function () {
            $(this).tooltip('hide')
        })    
        
        tooltip.on('mouseenter', function () {
            let that = $(this)
            that.tooltip('show');
            setTimeout(function(){
                that.tooltip('hide');
            }, 3000);
        })
    });
    
    function calculateTerminalNode(node) {
        const variableList = getListOfVariablesFromTerminalNodeToRoot(node, variables, [], SCALE)
        const distributions = getListOfDistributions(variableList, SCALE)
        if (distributions.length > 0) {
            let distribution = convoluteMultipleDistributions(distributions, SCALE)
            node.distribution = distribution
            let expectedValues = getExpectedValue(distribution)
            node.expectedValue = distribution.symetrical ? variableList.reduce((sum, v) => sum + getSymmetricalExpectedValue(v) ,0) : expectedValues.exp
            node.p10 = expectedValues.p10
            node.p90 = expectedValues.p90
            printTerminalNodePayoff(node)
        }
        
    }

    function getSymmetricalExpectedValue(variable) {
        if (variable.distribution == 'uniform'){
            return parseFloat((variable.low + variable.high) /2)
        }
        return parseFloat(variable.value)
    }

    function evaluateTree(node) {
        let edges = node.childEdges
        let expectedValue = {exp: 0, p10: 0, p90: 0}
        let edgeExpected = {exp: 0, p10: 0, p90: 0}
        let distribution
        if (edges.length > 0) {
            if (node.type == 'decision') {    
                let highestExpectedValue = Number.NEGATIVE_INFINITY
                for (let i = 0; i < edges.length; i++) {
                    let edge = edges[i] 
                    let edgeDistribution = getDistributionForVariable(getVariableForEdge(edge, variables), SCALE)
                    edge.distribution = edgeDistribution
                    edgeExpected = getExpectedValue(edgeDistribution)
                    edge.expectedValue = edgeExpected.exp
                    edge.p10 = edgeExpected.p10
                    edge.p90 = edgeExpected.p90
                    edge.expectedValue = replaceWithBaseValueIfSymmetricalVariable(edge, variables)
                    printEdgePayoff(edge)
                    
                    if (edge.childNode.childEdges.length > 0) {
                        let childNodeDistribution = evaluateTree(edge.childNode)
                        edgeDistribution = convolute(edgeDistribution, childNodeDistribution, SCALE)
                    }
                    let newExpectedValue = getExpectedValue(edgeDistribution)
                    if (newExpectedValue.exp > highestExpectedValue ) {
                        highestExpectedValue = newExpectedValue.exp
                        expectedValue = newExpectedValue
                        distribution = edgeDistribution
                        
                    }
                }
            } else if (node.type == 'chance') {
                let weightedDistributions = []
                for (let i = 0; i < edges.length; i++) {
                    let edge = edges[i]
                    let edgeDistribution = getDistributionForVariable(getVariableForEdge(edge, variables), SCALE)
                    edge.distribution = edgeDistribution
                    edgeExpected = getExpectedValue(edgeDistribution)
                    edge.expectedValue = edgeExpected.exp
                    edge.p10 = edgeExpected.p10
                    edge.p90 = edgeExpected.p90
                    edge.expectedValue = replaceWithBaseValueIfSymmetricalVariable(edge, variables)
                    printEdgePayoff(edge)
                    
                    if (edge.childNode.childEdges.length > 0) {
                        let childNodeDistribution = evaluateTree(edge.childNode)
                        edgeDistribution = convolute(edgeDistribution, childNodeDistribution, SCALE)
                    }
                    weightedDistributions.push({distribution: edgeDistribution, weight: getWeigth(edge)})

                }
                distribution =  mixture(weightedDistributions, SCALE)
                expectedValue = getExpectedValue(distribution)
            } 
        }
        
        node.distribution = distribution
        node.expectedValue = node.distribution ? node.distribution.symetrical ? getPrettyExpectedValue(node) : expectedValue.exp : expectedValue.exp
        node.p10 = expectedValue.p10
        node.p90 = expectedValue.p90
        printNodePayoff(node)
        return distribution  
    }

    function getPrettyExpectedValue(node) {
        if (node.type == 'terminal') {
            return 0
        }
        let sum = 0
        if (node.type == 'chance') {
            for (let i = 0; i < node.childEdges.length; i++){
               sum += getWeigth(node.childEdges[i]) *( node.childEdges[i].expectedValue + getPrettyExpectedValue(node.childEdges[i].childNode))
            }
            return sum
        }
        if (node.type == 'decision') {
            let max =  Number.NEGATIVE_INFINITY
            for (let i = 0; i < node.childEdges.length; i++){
                let val = getSymmetricalExpectedValue(getVariableForEdge(node.childEdges[i], variables)) + getPrettyExpectedValue(node.childEdges[i].childNode)
                if (val > max){    
                    max = val
                }
            }
            return max
        }
    }

    function replaceWithBaseValueIfSymmetricalVariable(edge, variables) {
        let variable = getVariableForEdge(edge, variables)
        if (edge.distribution.symetrical){
            return getSymmetricalExpectedValue(variable)
        }
        return edge.expectedValue
    }

    function printOptimalPath(root){
        if (root.childEdges.length == 0) {
            return
        } else if (root.type =='chance') {
            root.childEdges.map( edge => {
                edge.optimal = true
                let edgeElem = document.getElementById('edge-' + edge.$id)
                if (edgeElem == null) {
                    setTimeout(() => {
                        edgeElem = document.getElementById('edge-' + edge.$id)
                        edgeElem.classList.add("new-optimal");
                    }, 500);
                }
                else {
                    edgeElem.classList.add("new-optimal");
                }
                printOptimalPath(edge.childNode)
                
            })
        } else { 
            let max = Number.NEGATIVE_INFINITY
            let optimal = []
            root.childEdges.map( edge => {
                let value = 0
                if (edge.childNode.type == 'terminal') {
                    value = edge.expectedValue
                } else {
                    value = edge.expectedValue + edge.childNode.expectedValue
                }
                
                if (value > max) {
                    optimal = [edge.$id]
                    max = value
                } else if (value == max) {
                    optimal.push(edge.$id)
                }
            })
            root.childEdges.map( edge => {
                if (!optimal.includes(edge.$id)){  
                    printNotOptimalSubtree(edge)
                } else {
                    edge.optimal = true
                    let edgeElem = document.getElementById('edge-' + edge.$id)
                    if (edgeElem == null) {
                        setTimeout(() => {
                            edgeElem = document.getElementById('edge-' + edge.$id)
                            edgeElem.classList.add("new-optimal");
                        }, 500);
                    }
                    else {
                        edgeElem.classList.add("new-optimal");
                    }
                    printOptimalPath(edge.childNode)
                }
            })
        }
    }

    function printNotOptimalSubtree(edge) {
        edge.optimal = false
        let edgeElem = document.getElementById('edge-' + edge.$id)
        if (edgeElem) {
            edgeElem.classList.remove("new-optimal");
        }
        edge.childNode.childEdges.map( edge => printNotOptimalSubtree(edge) )
        
    }

    function printEdgePayoff(edge) {
        if (edge.computed.$displayValues.payoff) {
            edge.computed.$displayValues.payoff.n = Math.abs(edge.expectedValue)
            edge.computed.$displayValues.payoff.d = 1
            edge.computed.$displayValues.payoff.s = 1
            if (edge.expectedValue < 0) {
                edge.computed.$displayValues.payoff.s = -1
            }   
        }       
    }
    
    function printNodePayoff(node) {
        if ( (!(nodeHasError(node) || childrenHasError(node))) && node.computed.$displayValues.childrenPayoff) {  
            node.computed.$displayValues.childrenPayoff[0].n = Math.abs(node.expectedValue)
            node.computed.$displayValues.childrenPayoff[0].d = 1
            node.computed.$displayValues.childrenPayoff[0].s = 1
            if (node.expectedValue < 0) {
                node.computed.$displayValues.childrenPayoff[0].s = -1
            }
        }
    }
    
    function printTerminalNodePayoff(node) {
        if (!nodeHasError(node) && node.computed.$displayValues.aggregatedPayoff) {
            node.computed.$displayValues.aggregatedPayoff[0].n = Math.abs(node.expectedValue)
            node.computed.$displayValues.aggregatedPayoff[0].d = 1
            node.computed.$displayValues.aggregatedPayoff[0].s = 1
            if (node.expectedValue < 0) {
                node.computed.$displayValues.aggregatedPayoff[0].s = -1
            }
        }
    }
    
    function getNodeIdsWithErrors(validationResults) {
        const nodeIds = validationResults.map(tree =>
            Object.keys(tree.objectIdToError)     
            )
        return nodeIds.flat()
    
    }

    function getExpectedValue(distribution) {
        if (distribution.values.length ==1) {
            return {exp: parseFloat(distribution.a), p10: parseFloat(distribution.a), p90: parseFloat(distribution.a)}
        }
        var expectedValue = 0
        var p10 = 0
        var p90 = 0
        let foundp10 = false 
        let foundp90 = false
        let sum = 0
        for (let i = 0; i < distribution.values.length; i++) {
            var xValue = parseFloat(distribution.a) +(i*SCALE)
            if (!isNaN(distribution.values[i])) {
                expectedValue += xValue * distribution.values[i]
                sum += distribution.values[i]
                if (sum > 0.1 && !foundp10){ 
                    p10 = xValue
                    foundp10 = true
                }
                if (sum > 0.9 && !foundp90) {
                    p90 = xValue
                    foundp90 = true
                }
            }
        }
        return {exp: expectedValue, p10: p10, p90: p90}
    }

    function childrenHasError(node) {
        if (node.childEdges.length < 1){
            return nodeHasError(node)
        }
        else if (nodeHasError(node)) {
            return true
        }
        else {
            let anyChildrenHasError = node.childEdges.some( edge => childrenHasError(edge.childNode))
            return anyChildrenHasError
        }
    }
    
    function nodeHasError(node) {
        return nodesWithErrors.includes(node.$id)
    }
    
    function getWeigth(edge) {
        return edge.computed.probability.n / edge.computed.probability.d
    }

});

export function getExpectedEdgeAbsoluteValues(rootNode, variables) {
    if (rootNode.type == 'terminal') {
        return [0] 
    }
    let res = []
    for (var i = 0; i< rootNode.childEdges.length; i++ ) {
        let edge = rootNode.childEdges[i]
        let variable = getVariableForEdge(edge, variables)
        if (variable == "error") {
            res.push(1)
        }
        else if (variable.distribution != 'constant' && variable.name) {
            res.push(variable.high - variable.low)
        }
        if (variable.distribution == 'constant') {
            res.push(Math.abs(variable.value/5))
        }
        res = res.concat(getExpectedEdgeAbsoluteValues(edge.childNode, variables))
    }
    return res
}








// WEBPACK FOOTER //
// ./scripts/components/payoffs.js